export default __webpack_public_path__ + "static/media/post-link.413ef235.svg";